import { createApp } from 'vue';
import LottieToJpgConverter from '@/Components/LottieToJpgConverter.vue';
import '@styles/app.css';

createApp(LottieToJpgConverter).mount('#lottie-to-jpg-converter');
